// extracted by mini-css-extract-plugin
export var loader = "styles-module--loader--0yjK4";
export var spin = "styles-module--spin--9rFuN";